"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var serialize_1 = require("./serialize");
var tokenProps = [
    'token_type',
    'access_token',
    'expires',
    'expires_in',
    'issued',
    'scope',
    'state',
];
var Token = (function () {
    function Token(tokenish) {
        var _this = this;
        this.token_type = 'Bearer';
        var obj;
        if (tokenish instanceof Token) {
            return tokenish;
        }
        else if (typeof tokenish === 'string') {
            obj = serialize_1.parse(tokenish);
        }
        else if (typeof tokenish === 'object' && tokenish) {
            obj = tokenish;
        }
        else {
            obj = {};
        }
        tokenProps.forEach(function (prop) {
            if (prop in obj) {
                _this[prop] = obj[prop];
            }
        });
        ['refresh', 'refreshPromise', 'refreshTimeout'].forEach(function (prop) {
            Object.defineProperty(_this, prop, {
                configurable: false,
                enumerable: false,
                writable: true,
            });
        });
    }
    Object.defineProperty(Token.prototype, "expires_in", {
        set: function (value) {
            if (value) {
                this.expires = Date.now() + (1000 * Number(value));
                this.issued = Date.now();
            }
            else {
                this.expires = undefined;
            }
        },
        enumerable: true,
        configurable: true
    });
    Token.prototype.isValid = function (buffer) {
        if (buffer === void 0) { buffer = 0; }
        return !!this.access_token && Number(this.expires) > Date.now() + buffer;
    };
    Token.prototype.logout = function () {
        clearTimeout(this.refreshTimeout);
        this.refresh = undefined;
        this.refreshPromise = undefined;
        this.refreshTimeout = undefined;
    };
    Token.prototype.startRefreshTimer = function (refreshTimestamp) {
        var _this = this;
        clearTimeout(this.refreshTimeout);
        if (typeof refreshTimestamp === 'function') {
            this.refresh = refreshTimestamp(this);
        }
        else {
            this.refresh = this.expires;
        }
        var delay = Math.max(0, this.refresh - Date.now());
        this.refreshPromise = new Promise(function (resolve) {
            _this.refreshTimeout = setTimeout(function () { return resolve(_this); }, delay);
        });
        return this.refreshPromise;
    };
    Token.prototype.toString = function () {
        return serialize_1.stringify(this);
    };
    return Token;
}());
exports.default = Token;
//# sourceMappingURL=token.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@getgo/auth-client/lib/token.js
// module id = 432
// module chunks = 0